import * as React from 'react';

import classNames from 'classnames';

import s from './AlignedText.module.scss';

export interface AlignedTextProps {
    html: {
        html: string;
    }
    align?: 'left' | 'right';
}


const AlignedText: React.FC<AlignedTextProps> = ({ html = {}, align }) => {
    return (
        <div className={classNames(s.Root, {
            [s["Root--Left"]]: align === 'left',
            [s["Root--Right"]]: align === 'right',
        })} >
            <span dangerouslySetInnerHTML={{ __html: html.html }} />
        </div>
    );
};

export default AlignedText;
